import { focusControlElement } from "./focusControlElement";
import { isElementVisible } from "./isElementVisible";
import { autoScrollLogger } from "./logger";
export function scrollToElement(element, options) {
    if (isElementVisible(element) && !options.scrollIfVisible) {
        autoScrollLogger.log("Element is already visible", element);
        return;
    }
    autoScrollLogger.log("Scrolling to", element);
    element.scrollIntoView(options.scrollIntoViewOptions);
    if (options.focusControl) {
        focusControlElement(element);
    }
}
//# sourceMappingURL=scrollToElement.js.map